export const SAVE_COMPETITORS_CONFIG_REQUEST =
  "SAVE_COMPETITORS_CONFIG_REQUEST";
export const SAVE_COMPETITORS_CONFIG_SUCCESS =
  "SAVE_COMPETITORS_CONFIG_SUCCESS";
export const SAVE_COMPETITORS_CONFIG_FAILURE =
  "SAVE_COMPETITORS_CONFIG_FAILURE";
